module.exports = __webpack_public_path__ + "img/Monte_Kope_105.ddec741a.jpg";